<template>
  <Tree v-if="visible"
        :tree="stateTree"
        @toggle-node-opening="toggleExpandState"
        @toggle-node-selection="toggleSelectState"
        @toggle-parameter="toggleSelectState"/>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import VueCookie from 'vue-cookie';
import TreeMixin from "./TreeMixin";

export default {
  mixins: [TreeMixin],

  computed: {

    ...mapGetters({
      getAllAvailableChannels: 'getAllAvailableIndicators',
    }),
  },
  data() {
    return {
      mode: 'INDICATORS',
    };
  },

  methods: {
    checkChannel(indicatorId) {
      return !!this.getAllAvailableChannels.find(
        (stateIndicator) => stateIndicator.id === indicatorId,
      );
    },

    buildTree() {      
      let localTree = {
        name: 'Siti',
        selectable: false,
        visible: true,
        open: true,
        code: '__sites__',
        children: [],
      }

      if(this.sites.length > 1) {
        localTree.children = this.sites.map(site => {
          const s = _.cloneDeep(site)
          const node = {
            name: s.name,
            code: s.guid,
            key: s.guid,
            type: 'site',
            selectable: false,
            selected: false,
            open: !this.reportMode && this.expandedNodes.includes(s.guid),
            visible: true,
            children: s.indicators.map(indicator => this.makeIndicatorNode(indicator)),
            parameters: [],
          };

          return node;
        })
      } else {
        localTree.parameters = [];
        localTree.children = this.sites[0].indicators.map(indicator => this.makeIndicatorNode(indicator));
      }

      this.$store.commit('charts/setTree', localTree);

    },

    makeIndicatorNode(indicator) {
      return {
        code: indicator.id,
        type:'indicator',
        name: indicator.formula ? indicator.formula.name : '',
        selectable: true,
        selected: this.selectedSources.some(ss=>ss.code === indicator.id),
        children: [],
        visible: indicator.visible !== 0,
      };
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Charts/Tree/IndicatorsTree.vue